module.exports = __webpack_public_path__ + "static/media/by.7e717f96.svg";